export default "__VITE_ASSET__DfOWN8RK__"